import * as Highcharts from 'highcharts';
import { Component, Input } from '@angular/core';
import { BaseChartComponent } from '../basechart/basechart.component';

@Component({
  selector: 'app-polar',
  templateUrl: '../basechart/basechart.component.html',
})
export class PolarComponent extends BaseChartComponent<any> {
  @Input() titleY = '';
  @Input() suffix = '';

  options: Highcharts.Options = {
    chart: {
      polar: true,
      type: 'polar',
    },

    title: {
      text: this.title,
    },

    xAxis: {
      tickmarkPlacement: 'on',
      type: 'category',
    },

    yAxis: {
      visible: false,
    },

    tooltip: {
      valueSuffix: this.suffix,
    },

    plotOptions: {
      series: {
        stacking: 'normal',
        shadow: false,
        pointPlacement: 'on',
      },
    },

    series: undefined,
  };


  draw(renderingId: string) {
    this.options.title.text = this.title;

    const series = [];
    // format data
    for (let x = 0; x < this.data.xLabels.length; x++) {
      const serie = {
        data: [],
        name: this.data.xLabels[x],
        type: 'column',
      };

      // zip yLabels with data
      for (let y = 0; y < this.data.yLabels.length; y++) {
        const name = this.data.yLabels[y];
        const e = this.data.data[x][y];
        serie.data.push([name, e]);
      }
      series.push(serie);
    }
    this.options.series = series;
  }
}
